import React, { useEffect, useState } from 'react';
import PageHeader from 'components/common/PageHeader';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCollabById } from 'redux/colabsSlice';
import classNames from 'classnames';
import { Profile } from './components/editPage/Profile';

const UserEditPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const userLogged = useSelector(state => state.login.currentUser);
  const colab = useSelector(state => state.colabs.colab);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log(id);
    dispatch(getCollabById(id, setLoading));
  }, [id]);

  return (
    <div
      className={classNames({
        'loading-skeleton': loading
      })}
    >
      <PageHeader
        title={colab?.firstName + ' ' + colab?.lastName || ''}
        description="Edite los datos del usuario y sus permisos en el sistema."
        className="mb-3 bg-white"
      />

      <Profile userLogged={userLogged} user={colab} />
    </div>
  );
};

export default UserEditPage;
